import { render, staticRenderFns } from "./shopcart.vue?vue&type=template&id=6406a2b8&scoped=true&"
import script from "./shopcart.vue?vue&type=script&lang=js&"
export * from "./shopcart.vue?vue&type=script&lang=js&"
import style0 from "./shopcart.vue?vue&type=style&index=0&id=6406a2b8&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6406a2b8",
  null
  
)

export default component.exports